import {Capacitor} from '@capacitor/core';
import {PushNotifications} from '@capacitor/push-notifications';
import {fleetRequest,fleetSession} from './fleetDriverApi';

// Each mounted account owns its listeners; delayed callbacks cannot register a different account.
export function startFleetPush(session,language,onOpen){
 let active=true;const handles=[];
 const current=()=>active&&fleetSession()?.access_token===session.access_token;
 const add=async(name,callback)=>{const h=await PushNotifications.addListener(name,callback);if(active)handles.push(h);else await h.remove();};
 if(Capacitor.isNativePlatform())(async()=>{
  await add('registration',token=>{if(current())fleetRequest('POST','/driver/push-token',{token:token.value,language}).catch(()=>{});});
  await add('notificationActionPerformed',event=>{const data=event.notification?.data||{};if(current()&&data.fleet_owner===`${session.driver.company_id}:${session.driver.id}`)onOpen();});
  let permission=await PushNotifications.checkPermissions();
  if(permission.receive==='prompt')permission=await PushNotifications.requestPermissions();
  if(current()&&permission.receive==='granted')await PushNotifications.register();
 })().catch(()=>{});
 return()=>{active=false;handles.forEach(h=>h.remove());};
}
